export const scrollElementIntoView = (element, options = {
  behavior: 'smooth'
}) => {
  element?.scrollIntoView?.(options);
};
